import { render, staticRenderFns } from "./CoreDialog.vue?vue&type=template&id=3b46f144"
import script from "./CoreDialog.vue?vue&type=script&lang=js"
export * from "./CoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports